import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./pages/App";
// import reportWebVitals from "./reportWebVitals";
ReactDOM.render(_jsx(React.StrictMode, { children: _jsx(App, {}, void 0) }, void 0), document.getElementById("root"));



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 33
// module chunks = 0